// Export redux selectors
export const selectStaffServices = (state) => state.schedule.staffServices;
export const selectServiceLoadingStatus = (state) => state.schedule.fetchingData;